import { Icon as IconType } from 'iconsax-react';
import React, { ForwardedRef, forwardRef } from 'react';

import classNames from '../../helpers/classNames';
import styles from './IconButton.module.scss';

export interface IconButtonProps
  extends React.ComponentPropsWithoutRef<'button'> {
  Icon: IconType;
  iconClassName?: string;
  iconSize?: number;
  size?: 'extraSmall' | 'small' | 'main' | 'medium';
  variant?:
    | 'blackAndWhite'
    | 'default'
    | 'white'
    | 'blue'
    | 'transparent'
    | 'whiteAlert';
  withBorder?: boolean;
}

function IconButtonInner(
  {
    Icon,
    iconClassName,
    iconSize = 20,
    size = 'main',
    variant = 'default',
    withBorder,
    className,
    ...props
  }: IconButtonProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  return (
    <button
      ref={ref}
      className={classNames(
        [styles.container, className, styles[variant], styles[size]],
        { [styles.withBorder]: withBorder }
      )}
      {...props}
    >
      <Icon variant="Linear" color="currentColor" size={iconSize} className={iconClassName} />
    </button>
  );
}

const IconButton = forwardRef(IconButtonInner);

export default IconButton;
